import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-reject-reason-modal',
  templateUrl: './reject-reason-modal.component.html',
  styleUrls: ['./reject-reason-modal.component.css']
})
export class RejectReasonModalComponent {
  @Input() documentLabel = '';
  @Output() closeModal = new EventEmitter<void>();
  @Output() submitReason = new EventEmitter<string>();

  reasonText = '';

  onCloseModal() {
    this.closeModal.emit();
  }

  onSubmit() {
    if (!this.reasonText?.trim()) {
      return;
    }
    this.submitReason.emit(this.reasonText.trim());
  }
}
